import { reais } from "./dinheiro.js";
import { competenciaId } from "./competencia.js";
export const TABELAS_IRPF = [
    {
        vigenciaInicio: "2024-02-01",
        vigenciaFim: "2025-04-30",
        faixas: [
            { ate: reais(2259.2), aliquota: 0, parcelaADeduzir: 0 },
            { ate: reais(2826.65), aliquota: 0.075, parcelaADeduzir: reais(169.44) },
            { ate: reais(3751.05), aliquota: 0.15, parcelaADeduzir: reais(381.44) },
            { ate: reais(4664.68), aliquota: 0.225, parcelaADeduzir: reais(662.77) },
            { ate: null, aliquota: 0.275, parcelaADeduzir: reais(896.0) },
        ],
        deducaoPorDependente: reais(189.59),
        fonte: "Tabela historica. Nao usada para competencias de 2026.",
        verificadoAte: "2025-04-30",
    },
    {
        vigenciaInicio: "2025-05-01",
        vigenciaFim: null,
        faixas: [
            { ate: reais(2428.8), aliquota: 0, parcelaADeduzir: 0 },
            { ate: reais(2826.65), aliquota: 0.075, parcelaADeduzir: reais(182.16) },
            { ate: reais(3751.05), aliquota: 0.15, parcelaADeduzir: reais(394.16) },
            { ate: reais(4664.68), aliquota: 0.225, parcelaADeduzir: reais(675.49) },
            { ate: null, aliquota: 0.275, parcelaADeduzir: reais(908.73) },
        ],
        deducaoPorDependente: reais(189.59),
        fonte: "RFB, tabela progressiva mensal 2026 (Lei 15.191/2025). Conferido em 2026-08-19.",
        verificadoAte: "2026-12-31",
    },
];
export const DESCONTOS_SIMPLIFICADOS = [
    {
        vigenciaInicio: "2026-01-01",
        vigenciaFim: null,
        valor: reais(607.2),
        fonte: "Desconto simplificado mensal 2026. Conferido em 2026-08-19.",
        verificadoAte: "2026-12-31",
    },
];
export const REDUTORES = [
    {
        vigenciaInicio: "2026-01-01",
        vigenciaFim: null,
        limiteIsencao: reais(5000),
        limiteSuperior: reais(7350),
        coeficienteFixo: reais(978.62),
        coeficientePPM: 133_145,
        fonte: "Lei 15.270/2025. Conferido contra o Carne-Leao Web em 2026-08-19.",
        verificadoAte: "2026-12-31",
    },
];
function vigente(lista, ref) {
    return lista.filter((x) => x.vigenciaInicio <= ref && (x.vigenciaFim === null || x.vigenciaFim >= ref)).at(-1);
}
export function descontoSimplificadoParaCompetencia(c) {
    return vigente(DESCONTOS_SIMPLIFICADOS, `${competenciaId(c)}-01`)?.valor ?? 0;
}
export function redutorParaCompetencia(c) {
    return vigente(REDUTORES, `${competenciaId(c)}-01`);
}
/**
 * Redutor da Lei 15.270/2025.
 *
 * ARREDONDAMENTO: a RFB TRUNCA o produto `coeficiente * rendimento` em
 * centavos, nao arredonda. Observado no Carne-Leao Web com rendimento de
 * R$ 7.000, onde o produto da 932,015 exatos: a RFB usa 932,01 (redutor
 * 46,61, imposto 802,68), enquanto arredondar daria 932,02 (imposto 802,69).
 * Com R$ 6.000 o produto e exato e os dois metodos coincidem.
 *
 * Base: uma observacao. Se aparecer contra-exemplo, revisar aqui.
 *
 * A multiplicacao usa inteiros (PPM) porque em ponto flutuante o produto
 * pode cair em 93201.4999... e o truncamento passaria a errar por 1 centavo
 * em casos onde deveria ser exato.
 */
export function calcularRedutor(rendimento, r, impostoDevido = Number.POSITIVE_INFINITY) {
    // `>=` e nao `>`: truncar deixa 1 centavo residual exatamente em 7.350,
    // onde a lei diz que o redutor acaba.
    if (rendimento >= r.limiteSuperior)
        return 0;
    const alvo = rendimento <= r.limiteIsencao ? r.limiteIsencao : rendimento;
    const produto = Math.floor((alvo * r.coeficientePPM) / 1_000_000);
    // O redutor nunca passa do imposto: ele zera, nao gera credito. Em 5.000 a
    // formula truncada da 312,90 contra um imposto de 312,89 — cap resolve.
    return Math.max(0, Math.min(r.coeficienteFixo - produto, impostoDevido));
}
export function tabelaParaCompetencia(c) {
    const ref = `${competenciaId(c)}-01`;
    const tabela = TABELAS_IRPF.filter((t) => t.vigenciaInicio <= ref && (t.vigenciaFim === null || t.vigenciaFim >= ref)).at(-1);
    if (!tabela) {
        throw new Error(`sem tabela de IRPF para a competencia ${competenciaId(c)}`);
    }
    const avisos = [];
    if (tabela.verificadoAte === null || tabela.verificadoAte < ref) {
        avisos.push(`Tabela de IRPF aplicada a ${competenciaId(c)} nao foi verificada na fonte oficial ` +
            `(vigencia declarada: ${tabela.vigenciaInicio}). Confirmar antes de emitir DARF.`);
    }
    return { tabela, avisos };
}
/**
 * ARREDONDAMENTO: a RFB TRUNCA tambem o produto `base * aliquota`, como faz
 * com o redutor. Observado no Carne-Leao Web em 02/09/2026 (Mirian,
 * marco/2026): base 5.671,34 x 27,5% = 1.559,6185; a Receita usa 1.559,61
 * (imposto 508,21), e arredondar dava 1.559,62 (508,22, o que o DARF pagou
 * a maior por 1 centavo em mar/abr/jun/jul). Os casos do oraculo de agosto
 * nao pegaram porque toda base terminada em ,80 da produto exato a 27,5%.
 *
 * Aliquota em decimos de milesimo (27,5% -> 2750) para o produto ser
 * inteiro: em ponto flutuante 567134 * 0.275 pode cair em x,8499... e o
 * truncamento erraria onde deveria ser exato.
 */
export function impostoPelaTabela(base, tabela) {
    const faixa = tabela.faixas.find((f) => f.ate === null || base <= f.ate);
    if (!faixa)
        throw new Error("tabela de IRPF sem faixa final");
    const aliquotaDMM = Math.round(faixa.aliquota * 10_000);
    const produto = Math.floor((base * aliquotaDMM) / 10_000);
    return Math.max(0, produto - faixa.parcelaADeduzir);
}
//# sourceMappingURL=tabelas.js.map